import useTranslation from '../utils/useTranslation';

export default function LanguageSelector() {
  const { t, lang, setLang } = useTranslation();

  const next = lang === 'ar' ? 'en' : 'ar';
  const label = next === 'en' ? t('lang_english') : t('lang_arabic');

  return (
    <button
      type="button"
      className="lang-toggle"
      onClick={() => setLang(next)}
      aria-label={t('lang_label')}
    >
      <svg
        className="lang-globe"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
      <span className="lang-toggle-label" lang={next}>
        {label}
      </span>
    </button>
  );
}
